import { BlocklyError } from 'console/blockly/utils/blockly-error';
import { resolverX2B } from 'console/blockly/convertors/xml-2-blockly/index';
export function mainX2B(children) {
    if (children.length > 1) {
        throw new BlocklyError('mainX2B-0', 'Удалите отдельно стоящие блоки');
    }
    const child = children.item(0);
    if (!child) {
        return null;
    }
    try {
        return resolverX2B(child);
    }
    catch (e) {
        throw new BlocklyError('mainX2B-1', e);
    }
}
